// extracted by mini-css-extract-plugin
module.exports = {"container":"entities_container__ePAtN","errors":"entities_errors__2dNRY","okey":"entities_okey__3Tzo7","wrong":"entities_wrong__1TMgP","modal":"entities_modal__1_X_3"};